import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { getEndpoint } from 'src/app/core/services/functions.service';

export interface ConceptoComision {
  c_emp: string;
  codigo: string;
  descripcion: string;
  tipo: string;
  estado: string;
}

@Injectable({
  providedIn: 'root'
})
export class LocalConceptoComisionService {
  //private apiUrl = 'http://127.0.0.1:8000/concepto-comision';
  ENDPOINT = getEndpoint('coms_concepto_comision');
  constructor(private http: HttpClient) { }

  getConceptos(company: string): Observable<ConceptoComision[]> {
    return this.http.get<ConceptoComision[]>(`${this.ENDPOINT}`, {
      headers: { 'company': company }
    });
  }

  getConceptosActivos(company: string): Observable<ConceptoComision[]> {
    return this.http.get<ConceptoComision[]>(`${this.ENDPOINT}/activos`, {
      headers: { 'company': company }
    });
  }

  getConcepto(c_emp: string, codigo: string,company: string): Observable<ConceptoComision> {
    return this.http.get<ConceptoComision>(`${this.ENDPOINT}/${c_emp}/${codigo}`, {
      headers: { 'company': company }
    });
  }

  createConcepto(concepto: ConceptoComision,company: string): Observable<ConceptoComision> {
    return this.http.post<ConceptoComision>(`${this.ENDPOINT}`, concepto, {
      headers: { 'company': company }
    });
  }

  updateConcepto(c_emp: string, codigo: string, concepto: ConceptoComision,company: string): Observable<ConceptoComision> {
    return this.http.put<ConceptoComision>(`${this.ENDPOINT}/${c_emp}/${codigo}`, concepto, {
      headers: { 'company': company }
    });
  }

  deleteConcepto(c_emp: string, codigo: string, company: string): Observable<void> {
    return this.http.delete<void>(`${this.ENDPOINT}/${c_emp}/${codigo}`, {
      headers: { 'company': company }
    });
  }

  existeConcepto(c_emp: string, codigo: string, company: string): Observable<boolean> {
    return this.http.get<ConceptoComision>(`${this.ENDPOINT}/${c_emp}/${codigo}`, {
      headers: { 'company': company }
    }).pipe(
      map(() => true),
      catchError(() => of(false))
    );
  }
}